
const awsconfig = 
  {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": import.meta.env.VITE_APP_IDENTITY_ID,
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": import.meta.env.VITE_APP_POOL_ID,
    "aws_user_pools_web_client_id": import.meta.env.VITE_APP_CLIENT_ID,
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};

export default awsconfig;